import {makeAutoObservable} from 'mobx';
import ClassApiManager from 'services/API/ClassApi/ClassApiManager';
import {RootStore} from './RootStore';

export interface IClassMetaDataStore {
  subjectData: string[];
  setSubjectData(value: string[]): void;
  languageData: string[];
  setLanguageData(value: string[]): void;
  groupData: string[];
  setGroupData(value: string[]): void;
  getClassesMetadata(): Promise<void>;
}

export class ClassMetaDataStore implements IClassMetaDataStore {
  private classApiManager = new ClassApiManager();

  rootStore: RootStore;
  subjectData: string[] = [];
  languageData: string[] = [];
  groupData: string[] = [];

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    makeAutoObservable(this);
  }

  setSubjectData(value: string[]): void {
    this.subjectData = value;
  }

  setLanguageData(value: string[]): void {
    this.languageData = value;
  }

  setGroupData(value: string[]): void {
    this.groupData = value;
  }

  async getClassesMetadata() {
    try {
      const {languages, subjects, groups} =
        await this.classApiManager.getClassesMetadata();

      this.setSubjectData(subjects);
      this.setLanguageData(languages);
      this.setGroupData(groups);
    } catch (error) {
      console.log(error);
    }
  }
}
